export default "__VITE_ASSET__LHHJASlU__"